import { useState } from 'react'
import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import PaymentService from 'services/payment-service'

const defaultPrice = {
  value: 0,
  start_timestamp: undefined,
  end_timestamp: undefined,
  interval_count: 0,
  expire_timestamp: Math.floor(Date.now() / 1000),
}

const defaultPrices = [
  { ...defaultPrice, subscription: true, interval_count: 1 },
  { ...defaultPrice, subscription: true, interval_count: 3 },
  {
    ...defaultPrice,
    subscription: false,
    expire_timestamp: Math.floor(Date.now() / 1000),
  },
]

const VoucherCreator = () => {
  const [code, setCode] = useState('')
  const [codeToLoad, setCodeToLoad] = useState('')
  const [prices, setPrices] = useState(defaultPrices)
  const [teacherEmail, setTeacherEmail] = useState('')
  const [expire, setExpire] = useState('')

  const handleCreate = () => {
    PaymentService.createVoucher({
      code,
      prices,
      teacherEmail,
      expire,
    })
      .then(res => {
        if (res['error']) {
          alert(res['error'])
        } else {
          alert('Succes!')
          setCode('')
          setPrices(defaultPrices)
          setTeacherEmail('')
          setExpire('')
        }
      })
      .catch(res => alert(res))
  }

  const handleLoad = async () => {
    const resp = await PaymentService.loadVoucher(codeToLoad)

    setCode(resp.code)
    setPrices(resp.prices)
    setTeacherEmail(resp.created_by ?? '')
    setExpire(resp.expire_timestamp ?? '')
  }

  return (
    <DashboardLayout style={{ position: 'absolute' }}>
      <div className="mt-[30px] flex">
        <div className="text-base lg:text-xl capitalize self-center ">
          Code to load:
        </div>
        <input
          className="border border-gray-300 rounded-md p-2 ml-1 w-[300px] h-[30px]"
          id="code"
          placeholder="Code"
          value={codeToLoad}
          onChange={e => setCodeToLoad(e.target.value)}
        />
        <button
          type="button"
          className="bg-blue-500 hover:bg-blue-700 text-white text-sm lg:font-bold lg:text-xl px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
          onClick={handleLoad}
        >
          Load
        </button>
      </div>
      {prices.map((price, index) => (
        <div className="mt-[30px] flex" key={'price-' + index}>
          <div className="text-base lg:text-xl capitalize self-center ">
            Price {index}:
          </div>
          <input
            type="number"
            className="border border-gray-300 rounded-md p-2 ml-1 w-[100px] h-[30px]"
            placeholder="0"
            value={price.value}
            onChange={e =>
              setPrices(current =>
                current.map((val, ind) =>
                  ind === index ? { ...val, value: e.target.value } : val,
                ),
              )
            }
          />
          <div className="text-base lg:text-xl capitalize self-center ">
            {' '}
            Subscription:
          </div>
          <input
            type="checkbox"
            placeholder="0"
            checked={price.subscription === true}
            onChange={e =>
              setPrices(current =>
                current.map((val, ind) =>
                  ind === index
                    ? { ...val, subscription: !val.subscription }
                    : val,
                ),
              )
            }
          />
          {price.subscription ? (
            <>
              {' '}
              Interval (months):{' '}
              <input
                type="number"
                className="border border-gray-300 rounded-md p-2 ml-1 w-[100px] h-[30px]"
                placeholder="0"
                value={price.interval_count}
                onChange={e =>
                  setPrices(current =>
                    current.map((val, ind) =>
                      ind === index
                        ? { ...val, interval_count: e.target.value }
                        : val,
                    ),
                  )
                }
              />
            </>
          ) : (
            <>
              {' '}
              Expire timestamp:{' '}
              <input
                type="number"
                className="border border-gray-300 rounded-md p-2 ml-1 w-[200px] h-[30px]"
                placeholder="0"
                value={price.expire_timestamp}
                onChange={e =>
                  setPrices(current =>
                    current.map((val, ind) =>
                      ind === index
                        ? { ...val, expire_timestamp: e.target.value }
                        : val,
                    ),
                  )
                }
              />
            </>
          )}
          Start timestamp:{' '}
          <input
            type="number"
            className="border border-gray-300 rounded-md p-2 ml-1 w-[200px] h-[30px]"
            placeholder="0"
            value={price.start_timestamp}
            onChange={e =>
              setPrices(current =>
                current.map((val, ind) =>
                  ind === index
                    ? { ...val, start_timestamp: e.target.value }
                    : val,
                ),
              )
            }
          />
          End timestamp:{' '}
          <input
            type="number"
            className="border border-gray-300 rounded-md p-2 ml-1 w-[200px] h-[30px]"
            placeholder="0"
            value={price.end_timestamp}
            onChange={e =>
              setPrices(current =>
                current.map((val, ind) =>
                  ind === index
                    ? { ...val, end_timestamp: e.target.value }
                    : val,
                ),
              )
            }
          />
        </div>
      ))}
      <button
        type="button"
        className="mt-[30px] bg-blue-500 hover:bg-blue-700 text-white text-sm lg:font-bold lg:text-xl px-1 lg:px-2 rounded disabled:bg-gray-600"
        onClick={() => setPrices(current => [...current, defaultPrice])}
      >
        Add price
      </button>
      <div className="mt-[30px] flex">
        <div className="text-base lg:text-xl capitalize self-center ">
          Teacher email:
        </div>
        <input
          className="border border-gray-300 rounded-md p-2 ml-1 w-[300px] h-[30px]"
          id="teacher-email"
          placeholder="example@gmail.com"
          value={teacherEmail}
          onChange={e => setTeacherEmail(e.target.value)}
        />
      </div>
      <div className="mt-[30px] flex">
        <div className="text-base lg:text-xl capitalize self-center ">
          Expire:
        </div>
        <input
          type="date"
          className="border border-gray-300 rounded-md p-2 ml-1 w-[300px] h-[30px]"
          id="expire"
          value={expire}
          onChange={e => setExpire(e.target.value)}
        />
      </div>
      <div className="mt-[30px] flex">
        <div className="text-base lg:text-xl capitalize self-center ">
          Code to add:
        </div>
        <input
          className="border border-gray-300 rounded-md p-2 ml-1 w-[300px] h-[30px]"
          id="code"
          placeholder="Code"
          value={code}
          onChange={e => setCode(e.target.value)}
        />
      </div>
      <div className="mt-[30px] flex">
        <button
          type="button"
          className="bg-blue-500 hover:bg-blue-700 text-white text-sm lg:font-bold lg:text-xl px-1 lg:py-1 lg:px-2 rounded disabled:bg-gray-600"
          onClick={handleCreate}
        >
          Create
        </button>
      </div>
    </DashboardLayout>
  )
}
export default VoucherCreator
